import Vue from 'vue';
import axios from 'axios';
import '../../filters';
import moment from 'moment';
import * as files from '../../fileUtils';
import { WebCam } from 'vue-web-cam';
import { find, head } from 'lodash';
Vue.component(WebCam.name, WebCam);

//import WebCam from 'vue-web-cam';
//Vue.use(WebCam);

const uiDateFormat = 'DD/MM/YYYY';

function loadView(view) {
  return () => import(/* webpackChunkName: "view-[request]" */ `${view}.vue`)
}

export default {
  name: 'Logs',
  components: {
    CustomFieldsComp: require('../../components/customFields.vue').default,
    AttachmentsComp: require('../../components/attachments.vue').default,
    LineComp: require('../../components/charts/line.vue').default,
    BarComp: require('../../components/charts/bar.vue').default,
    LogComp: loadView('./log'),
    WebCam,
  },
  data: function () {
    return {
      apps: [],
      message: '',
      showFilters: true,
      search: '',
      loggedInUser: '',

      chartDataLine: {
        labels: ['January', 'February'],
        datasets: [
          {
            label: '',
            borderColor: '#f87979',
            borderWidth: 3,
            pointBorderColor: '#ff0000',
            pointBorderWidth: 2,
            pointRadius: 6,
            pointHoverRadius: 6,
            data: [40, 20],
            fill: false,
          }
        ]
      },
      chartDataBar: {
        labels: ['January', 'February'],
        datasets: [
          {
            label: '',
            backgroundColor: '#ffE0E6',
            borderColor: '#ff0000',
            borderWidth: 1,
            data: [40, 20]
          }
        ]
      },
      chartOptions: {
        responsive: false,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: 'Chart.js Line Chart'
        },
        elements: {
          line: {
            tension: 0, // disables bezier curves
          },
          animation: {
            duration: 3000, // general animation time
          },
        }
      },

      groupOptions: { pageSize: 10, total: 0, page: 1, filterText: this.search },
      monitoringOptions: { pageSize: 500, total: 0, page: 1, filterText: '' },
      logOptions: { pageSize: 10, total: 0, page: 1 },
      monitoringProgramOptions: { pageSize: 500, total: 0, page: 1 },
      monitoringProgramElementOptions: { pageSize: 500, total: 0, page: 1 },
      bShowConfirm: false,
      bAutoSelectNewRecord: false,
      bUseMonitoringPrograms: false,
      bGPSFiltering: false,
      bShowGraph: false,
      bDisableButton: false,
      bShowElementUserRef: false,
      bShowElementExternalRef: false,
      bShowElementLogDescription: false,
      bShowElementLogExternalRef: false,
      iGraphKey: 0,
      DeleteLogBatchId: -1,
      elementType: '',
      elementTypes: [],
      elementTypeId: -1,
      element: '',
      elements: [],
      elementId: -1,
      elementName: 'fullname',
      elementNameValue: '',
      monitoringProgramId: 0,
      monitoringPrograms: [],
      logGroup: '',
      logGroups: [],
      logGroupId: -1,
      logReadingBatches: [],
      logsPerElement: [],
      logPerElementId: -1,
      customFields: { items: [] },
      readingBatchId: -1,
      editingLog: {},
      attachments: {
        files: [],
        permissions: { add: true, delete: true, download: true, },
        sort: true,
        download: this.download,
        mimeTypes: 'image/png,image/jpeg,application/pdf,application/msword,application/excel',
        multiple: false,
        maxFilesNumber: 3,
        cntrlItemsHelp: []
      },
      columnHeaders: [
        { id: 1, name: this.$t('logs.ReadingDate') },
      ],
      footerColumns: [],
      finalColumns: [],
      finalData: [],
      showEditLog: false,
      showImage: false,
      img: null,
      camera: null,
      deviceId: null,
      devices: [],
      active: 'first',
      first: true,
      second: false,
      periodBeginDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      periodEndDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1),
      periodBeginDateTemp: null,
      periodEndDateTemp: null,
      geoLocation: null,
      totalRowGroup: 0,
      monitoringPageSet: {
        totalRow: 0,//required option
        language: 'en', //this.$i18n.locale, //'el',//default: 'cn'
        pageSizeMenu: [10, 25, 50]//default: [10, 20, 50, 100]
      },
      monitoringProgramElementPageSet: {
        totalRow: 0,//required option
        language: 'en', //this.$i18n.locale, //'el',//default: 'cn'
        pageSizeMenu: [5, 10, 25]//default: [10, 20, 50, 100]
      },
      totalRowLog: 0,
      dateRange: 6,
      dateRanges: [
        { id:  0, name: this.$t('BOC.CustomRange')   },
        { id:  1, name: this.$t('BOC.CurrentDay')    },
        { id:  2, name: this.$t('BOC.Last5Days')     },
        { id:  3, name: this.$t('BOC.Last10Days')    },
        { id:  4, name: this.$t('BOC.Last20Days')    },
        { id:  5, name: this.$t('BOC.Last30Days')    },
        { id:  6, name: this.$t('BOC.CurrentMonth')  },
        { id:  7, name: this.$t('BOC.PreviousMonth') },
        { id:  8, name: this.$t('BOC.Last2Months')   },
        { id:  9, name: this.$t('BOC.Last3Months')   },
        { id: 10, name: this.$t('BOC.Last6Months')   },
        { id: 11, name: this.$t('BOC.Last12Months')  }
      ],
    }
  },
  computed: {
    languageLocale: function () {
      return this.$i18n.locale;
    },
    device: function () {
      return find(this.devices, n => n.deviceId == this.deviceId);
    },
    customFieldsLength: function () {
      return (this.customFields.items !== null)? this.customFields.items.length: 0;
    },
  },
  watch: {
    languageLocale: function (value) {
      this.columnHeaders[0].name = this.$t('logs.ReadingDate');
      this.dateRanges = [
        { id: 0, name: this.$t('BOC.CustomRange')   },
        { id: 1, name: this.$t('BOC.CurrentDay')    },
        { id: 2, name: this.$t('BOC.Last5Days')     },
        { id: 3, name: this.$t('BOC.Last10Days')    },
        { id: 4, name: this.$t('BOC.Last20Days')    },
        { id: 5, name: this.$t('BOC.Last30Days')    },
        { id: 6, name: this.$t('BOC.CurrentMonth')  },
        { id: 7, name: this.$t('BOC.PreviousMonth') },
        { id: 8, name: this.$t('BOC.Last2Months')   },
        { id: 9, name: this.$t('BOC.Last3Months')   },
        { id: 10, name: this.$t('BOC.Last6Months')  },
        { id: 11, name: this.$t('BOC.Last12Months') }
      ];
    },
    bGPSFiltering: function (val) {
      this.getElements();
    },
    camera: function (id) {
      this.deviceId = id;
    },
    devices: function () {
      // Once we have a list select the first one
      let firsty = head(this.devices);
      if (firsty) {
        this.camera = firsty.deviceId;
        this.deviceId = firsty.deviceId;
      }
    },
    periodBeginDate: function (value) {
      if (this.dateRange === 0) {
        this.setDateRanges(0);
      }
    },
    periodEndDate: function (value) {
      if (this.dateRange === 0) {
        this.setDateRanges(0);
      }
    },
    dateRange: function (value) {
      if (value === 0)
        return;
      this.setDateRanges(value);
    },
    element: function (value) {
      this.elementId = value !== null? value.id: -1;

      if ((this.bShowElementUserRef === true) && (this.bShowElementExternalRef === true))
        this.elementNameValue = value !== null ? value.fullname: '';
      if ((this.bShowElementUserRef === true) && (this.bShowElementExternalRef === false))
        this.elementNameValue = value !== null ? value.name: '';
      if ((this.bShowElementUserRef === false) && (this.bShowElementExternalRef === true))
        this.elementNameValue = value !== null ? value.externalRef: '';

      this.$refs.selectElement.open = false;
      if (this.elementTypeId > 0 && this.elementId > 0) {
        if ((this.bUseMonitoringPrograms === true) && (this.monitoringProgramId > 0))
          this.getMonitoringProgramLogGroups();
        else
          this.getLogGroups();
      }
        
    },
    elementType: function (value) {
      this.elementTypeId = value === null ? -1 : value.id;
      this.elementType = value === null ? '' : value;
      this.$refs.selectType.open = false;
      if (this.bUseMonitoringPrograms === true)
        this.getMonitoringPrograms();
      this.logGroups = [];
      this.elements = [];
      this.element = '';
      this.elementId = -1;
      if (value !== null)
        this.getElements();
    },
    monitoringProgramId: function (value) {
      if (value > 0)
        this.getMonitoringProgramElements();
      else
        this.getElements();
    },
  },
  created() {
    this.loggedInUser = this.$localStorage.get('_login');
    var geoOptions = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0
    };
    var geo = navigator.geolocation.getCurrentPosition(
      (pos) => { this.geoLocation = pos; },
      (err) => { this.$alertMsg(err.message); },
      geoOptions
    );
    this.getProfileHydrology();
    this.getShowRef();
    this.getElementTypes();
  },
  methods: {
    datePickerBeginOpened() {
      this.periodBeginDateTemp = this.periodBeginDate;
    },
    datePickerBeginClosed() {
      setTimeout(() => {
        if (this.periodBeginDateTemp !== this.periodBeginDate)
          this.dateRange = 0;
      }, 500);
    },
    datePickerEndOpened() {
      this.periodEndDateTemp = this.periodEndDate;
    },
    datePickerEndClosed() {
      setTimeout(() => {
        if (this.periodEndDateTemp !== this.periodEndDate)
          this.dateRange = 0;
      }, 500);
    },
    searchLogs() {
      var parameter = {
        ElementTypeId: this.elementTypeId,
        ElemenId: this.elementId,
        GroupId: this.logGroupId,
        LogPerElementId: this.logPerElementId,
        ListOptions: this.logOptions,
        PeriodBegin: this.periodBeginDate,
        PeriodEnd: this.periodEndDate
      };

      parameter.PeriodBegin.setHours(0, 0, 0, 0);
      parameter.PeriodEnd.setHours(0, 0, 0, 0);

      this.getLogs(parameter);

      this.dateRange = 0;
    },
    getShowRef() {
      axios.post('/Utility/GetSettings')
        .then(response => {
          if (response.data.data.status == 0) {
            this.bShowElementUserRef = response.data.value.isShowElementUserRef;
            this.bShowElementExternalRef = response.data.value.isShowElementExternalRef;
            this.bShowElementLogDescription = response.data.value.isShowElementLogDescription;
            this.bShowElementLogExternalRef = response.data.value.isShowElementLogExternalRef;

            if ((this.bShowElementUserRef === true) && (this.bShowElementExternalRef === true))
              this.elementName = 'fullname';
            if ((this.bShowElementUserRef === true) && (this.bShowElementExternalRef === false))
              this.elementName = 'name';
            if ((this.bShowElementUserRef === false) && (this.bShowElementExternalRef === true))
              this.elementName = 'externalRef';
          }
        });
    },
    dateCompare(a, b) {
      return new Date(a.readingDate).getTime() - new Date(b.readingDate).getTime();
    },
    dateCompareDesc(a, b) {
      return new Date(b.readingDate).getTime() - new Date(a.readingDate).getTime();
    },
    showChart(header) {

      if (this.bShowGraph === true && this.iGraphKey === header.logPerElementId) {
        this.bShowGraph = false;
        return;
      }

      this.iGraphKey = header.logPerElementId;

      var xValues = ['Dates'];
      var yValues = ['Values'];

      var iLogPerElementId = header.logPerElementId;

      var xValues = ['x'];
      var yValues = ['Log Reading Value'];
      var yValueNumbers = [];

      var readingBatches = [];

      this.logReadingBatches.forEach((item) => {
        var readingBatch = item.readings.filter(p => p.logPerElementId == header.logPerElementId);
        readingBatches.push(readingBatch[0]);
      });

      readingBatches.sort(this.dateCompare).forEach((item) => {
        xValues.push(moment(item.readingDate).format(uiDateFormat));
        yValues.push(item.reading);
        yValueNumbers.push(parseFloat(item.reading));
      });

      xValues = xValues.slice(1);

      this.chartDataLine.labels = xValues;
      //this.chartDataLine.datasets[0].label = 'avg: ' + header.averageReading + ', max: ' + header.maxReading + ', min: ' + header.minReading + ', value';
      this.chartDataLine.datasets[0].data = yValueNumbers;

      this.chartDataBar.labels = xValues;
      //this.chartDataBar.datasets[0].label = 'avg: ' + header.averageReading + ', max: ' + header.maxReading + ', min: ' + header.minReading + ', value';
      this.chartDataBar.datasets[0].data = yValueNumbers;

      this.chartOptions.title.display = true;
      this.chartOptions.title.text = header.name + ', avg: ' + header.averageReading + ', max: ' + header.maxReading + ', min: ' + header.minReading;

      this.bShowGraph = true;
    },
    formatReadingDate(value) {
      return moment(String(value)).format('DD/MM/YYYY HH:mm');
    },
    savePhoto() {
      this.processPhotos();
      this.showImage = false;
    },
    discardPhoto() {
      this.img = null;
      this.showImage = false;
    },
    onCapture() {
      this.img = this.$refs.webcam.capture();
      this.$forceUpdate();
      this.showImage = true;
    },
    onStarted(stream) {
      //console.log('On Started Event', stream);
    },
    onStopped(stream) {
      //console.log('On Stopped Event', stream);
    },
    onStop() {
      this.$refs.webcam.stop();
    },
    onStart() {
      this.$refs.webcam.start();
    },
    onError(error, stream) {
      console.log('On Error Event', error, stream);
    },
    onCameras(cameras) {
      this.devices = cameras;
      //console.log('On Cameras Event', cameras);
    },
    onCameraChange(deviceId) {
      this.deviceId = deviceId;
      this.camera = deviceId
      //console.log('On Camera Change Event', deviceId);
    },
    getClass(id) {
      return (id === this.readingBatchId) ? 'selected' : 'logs';
    },
    getLogId(iLogPerElementId, iGroupBatchId) {
      var readings = this.logReadingBatches.filter(t => t.groupBatchId == iGroupBatchId)[0].readings;
      var log = readings.filter(t => t.logPerElementId == iLogPerElementId)[0];
      return log? log.logId: -1;
    },
    download(id) {
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/Log/DownloadAttachment', { Value: id }, { responseType: 'blob' })
        .then(files.getFile)
        .then((link) => {
          link.click();
        })
        .then(response => {
          loader.hide();
        })
        .catch((err) => {
          loader.hide();
          console.log(err)
        })
    },
    getAttachments(logId) {
      this.bDisableButton = true;
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/Log/GetAttachments', { Value: logId })
        .then(response => {
          if (response.data.data.status == 0) {
            var files = response.data.items;
            this.attachments.files = [];
            for (var i = 0; i < files.length; ++i) {
              var file = files[i];
              this.attachments.files.push({ id: file.id, seqId: 0, deleted: false, name: file.fileName });
            }
          }
          else
            this.closeWithMessage(this.$t('messages.CannotGetAttachmentsFromServer'), 1);
          this.bDisableButton = false;
          loader.hide();
        })
        .catch(e => {
          this.bDisableButton = false;
          loader.hide();
          this.$router.push('/login');
        })
    },
    processPhotos() {
      var logId = -1;

      if (!this.img)
        return;

      if (this.readingBatchId > 0)
        logId = this.logReadingBatches.filter(item => item.groupBatchId == this.readingBatchId)[0].readings[0].logId;

      if (logId <= 0)
        return;

      var formData = new FormData();
      formData.append("logId", logId.toString());
      formData.append("photoBase64", this.img)

      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });

      return axios.post('/Log/ProcessPhoto', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(response => {
        this.$root.$emit('camera_photos_updated');
        var logId = this.logReadingBatches.filter(item => item.groupBatchId == this.readingBatchId)[0].readings[0].logId;
        this.getAttachments(logId);
        loader.hide();
      })
        .catch(e => {
          loader.hide();
          this.$router.push('/login');
          return false;
        });
    },
    processAttachments(uploadFiles, deleteFiles) {
      var logId = -1;

      if (this.readingBatchId > 0)
        logId = this.logReadingBatches.filter(item => item.groupBatchId == this.readingBatchId)[0].readings[0].logId;

      var formData = new FormData();
      formData.append("logId", logId.toString());

      for (var i = 0; i < uploadFiles.length; ++i)
        formData.append("uploadFiles", uploadFiles[i]);

      for (var i = 0; i < deleteFiles.length; ++i)
        formData.append("deleteFiles", deleteFiles[i]);

      this.bDisableButton = true;
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/Log/ProcessAttachments', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(response => {
          if (response.data.data.status == 0) {
            this.$alertMsg(this.$t('messages.AttachmentSavedSuccess'), 2);
            this.getAttachments(logId);
          }
          else
            this.$alertMsg(response.data.data.text);
          this.bDisableButton = false;
          loader.hide();
        })
        .catch(e => {
          this.bDisableButton = false;
          loader.hide();
          this.$router.push('/login');
          return false;
        });
    },
    saveAttachments() {
      if (this.bDisableButton === true)
        return;

      var newFiles = [];
      var deleteFiles = [];

      this.attachments.files.forEach(function (file) {
        if (file.id < 0) // new
          newFiles.push(file.file);
        else if (file.deleted)
          deleteFiles.push(file.id);
      });

      if (deleteFiles.length > 0 || newFiles.length > 0)
        this.processAttachments(newFiles, deleteFiles);
    },
    getCustomFields(logId) {
      var parameter = {
        Value: logId
      };
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/Log/GetCustomFields', parameter)
        .then(response => {
          this.customFields.items = response.data.items;
          this.$root.$emit('custom_fields_updated');
          loader.hide();
        })
        .catch(e => {
          loader.hide();
          this.$router.push('/login');
          return false;
        })
    },
    addColumnHeaders() {

      this.finalColumns = [];
      this.finalColumns = this.columnHeaders.slice(0);

      for (var i = 0; i < this.logsPerElement.length; i++) {
        var newColumnHeader = {
          id: this.finalColumns.length + 1,
          name: this.logsPerElement[i].name + ' (' + this.logsPerElement[i].unitName + ')',
          logPerElementId: this.logsPerElement[i].logPerElementId,
          averageReading: this.logsPerElement[i].averageReading.toFixed(2),
          maxReading: this.logsPerElement[i].maxReading.toFixed(2),
          minReading: this.logsPerElement[i].minReading.toFixed(2),
        };
        if (this.bShowElementLogExternalRef === true)
          newColumnHeader.name = this.logsPerElement[i].name + (this.logsPerElement[i].externalRef.length > 0 ? '-' + this.logsPerElement[i].externalRef:'') + ' (' + this.logsPerElement[i].unitName + ')'
        this.finalColumns.push(newColumnHeader);
      }

      this.footerColumns = [];
      this.footerColumns = this.finalColumns.slice(1);

    },
    addColumnData() {

      this.finalData = [];

      for (var i = 0; i < this.logReadingBatches.length; i++) {

        var newRecord = {
          id: this.finalData.length + 1,
          groupBatchId: this.logReadingBatches[i].groupBatchId,
          readingDate: new Date(),
          isEditable: true,
          isForcedReading: false,
          clockOver: false,
          finalized: false,
          stampUser: '',
          stampDate: new Date()
        };

        for (var j = 0; j < this.logsPerElement.length; j++) {
          newRecord.readingDate = this.logReadingBatches[i].readings[j].readingDate;
          newRecord.isEditable = this.logReadingBatches[i].readings[j].isEditable;
          newRecord.isForcedReading = this.logReadingBatches[i].readings[j].isForcedReading;
          newRecord.clockOver = this.logReadingBatches[i].readings[j].clockOver;
          newRecord.finalized = this.logReadingBatches[i].readings[j].finalized;
          newRecord.stampUser = this.logReadingBatches[i].readings[j].stampUser;
          newRecord.stampDate = this.logReadingBatches[i].readings[j].stampDateTime;

          var precision = this.logsPerElement[j].precision;
          var num = this.logReadingBatches[i].readings[j].reading.toFixed(precision);

          this.logReadingBatches[i].readings[j].reading = num;
          newRecord[this.logsPerElement[j].logPerElementId.toString()] = num;
        }

        this.finalData.push(newRecord);
      }
      this.finalData = this.finalData.sort(this.dateCompareDesc);
    },
    setDateRanges(iKey) {

      switch (iKey) {
        case -1: //Custom Date
          return;
        case 0: //Custom Date
          // do nothing
          break;
        case 1: //Current Day
          this.periodEndDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1);
          this.periodBeginDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
          break;
        case 2: //Last 5 Days
          this.periodEndDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1);
          this.periodBeginDate = this.addDays(this.periodEndDate, -5);
          break;
        case 3: //Last 10 Days
          this.periodEndDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1);
          this.periodBeginDate = this.addDays(this.periodEndDate, -10);
          break;
        case 4: //Last 20 Days
          this.periodEndDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1);
          this.periodBeginDate = this.addDays(this.periodEndDate, -20);
          break;
        case 5: //Last 30 Days
          this.periodEndDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1);
          this.periodBeginDate = this.addDays(this.periodEndDate, -30);
          break;
        case 6: //Current Month
          this.periodEndDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1);
          this.periodBeginDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
          break;
        case 7: //Previous Month
          this.periodEndDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
          this.periodBeginDate = this.addMonths(this.periodEndDate, -1);
          break;
        case 8: //Last 2 Months
          this.periodEndDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1);
          this.periodBeginDate = this.addMonths(this.periodEndDate, -2);
          break;
        case 9: //Last 3 Months
          this.periodEndDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1);
          this.periodBeginDate = this.addMonths(this.periodEndDate, -3);
          break;
        case 10: //Last 6 Months
          this.periodEndDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1);
          this.periodBeginDate = this.addMonths(this.periodEndDate, -6);
          break;
        case 11: //Last 12 Months
          this.periodEndDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1);
          this.periodBeginDate = this.addMonths(this.periodEndDate, -12);
          break;
        default: //Current Month
          this.periodEndDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1);
          this.periodBeginDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
      }

      var parameter = {
        ElementTypeId: this.elementTypeId,
        ElemenId: this.elementId,
        GroupId: this.logGroupId,
        LogPerElementId: this.logPerElementId,
        ListOptions: this.logOptions,
        PeriodBegin: this.periodBeginDate,
        PeriodEnd: this.periodEndDate
      };

      parameter.PeriodBegin.setHours(0, 0, 0, 0);
      parameter.PeriodEnd.setHours(0, 0, 0, 0);

      this.getLogs(parameter);
    },
    getLogReadingValue(iGroupBatch, iLogPerElement) {
      var readingBatch = this.logReadingBatches.filter(t => t.groupBatchId == iGroupBatch)[0].readings;
      var rdg = readingBatch.filter(t => t.logPerElementId == iLogPerElement)[0];
      return rdg? rdg.reading: 0;
    },
    //getElementTypeText(iKey) {
    //  return (this.elementTypes.filter(t => t.id == iKey).length > 0) ? this.elementTypes.filter(t => t.id == iKey)[0].name : '';
    //},
    groupPageChange(pInfo) {
      var parameter = {
        ElementTypeId: this.elementTypeId,
        ElemenId: this.elementId,
        ListOptions: {
          PageSize: pInfo.pageSize,
          Page: pInfo.pageNumber,
          FilterText: this.search
        }
      };
      var parameterPrograms = {
        ElementTypeId: this.elementTypeId,
        ProgramId: this.monitoringProgramId,
        ListOptions: {
          PageSize: pInfo.pageSize,
          Page: pInfo.pageNumber,
          FilterText: this.search
        }
      };
      
      if ((this.bUseMonitoringPrograms === true) && (this.monitoringProgramId > 0))
        this.getMonitoringProgramLogGroupsAux(parameterPrograms);
      else
        this.getLogGroupsAux(parameter);
    },
    getMonitoringProgramLogGroupsAux(parameter) {
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/Hydrology/GetMonitoringProgramLogGroups', parameter)
        .then(response => {
          this.logGroups = response.data.items;
          this.groupOptions.total = response.data.count;
          this.totalRowGroup = response.data.count;
          loader.hide();
        })
        .catch(e => {
          loader.hide();
          this.$router.push('/login');
          return false;
        })
    },
    getLogGroupsAux(parameter) {
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/Log/GetLogGroups', parameter)
        .then(response => {
          this.logGroups = response.data.items;
          this.groupOptions.total = response.data.count;
          this.totalRowGroup = response.data.count;
          loader.hide();
        })
        .catch(e => {
          loader.hide();
          this.$router.push('/login');
          return false;
        })
    },
    getMonitoringPrograms() {
      var parameter = {
        ElementTypeId: this.elementTypeId,
        ListOptions: this.monitoringOptions
      };
      parameter.ListOptions.filterText = this.search;
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/Hydrology/GetMonitoringPrograms', parameter)
        .then(response => {
          //console.log("response", response)
          this.monitoringPrograms = [];
          var monProgAll = {
            category: '',
            dataSource: '',
            employee: 'Edams User',
            frequency: 2,
            name: 'All Programs',
            origin: '',
            preProcessing: '',
            programId: 0,
            remarks: '',
            type: 'Quantity'
          };
          this.monitoringPrograms.push(monProgAll);

          response.data.items.forEach(item => this.monitoringPrograms.push(item));

          this.monitoringOptions.total = response.data.count + 1;
          this.monitoringPageSet.totalRow = response.data.count + 1;

          this.monitoringProgramId = 0;
        })
        .catch(e => {
          console.log("err", e);
          this.$alertMsg(e);
         // this.$router.push('/login');
          return false;
        })
        .finally(loader.hide())
    },
    getMonitoringProgramElements() {
      var parameter = {
        ProgramId: this.monitoringProgramId, // All: SamplingPointId = 0
        ListOptions: { pageSize: 500, total: 0, page: 1, filterText: '' },
      };
      axios.post('/Hydrology/GetMonitoringProgramElements', parameter)
        .then(response => {
          if (response.data.data.status == 0) {
            response.data.items.forEach((item) => { item.fullname = item.name + (item.externalRef.length > 0 ? " - " + item.externalRef : ""); });
            this.elements = response.data.items;

            this.monitoringProgramElementOptions.total = response.data.count;
            this.monitoringProgramElementPageSet.totalRow = response.data.count;
          }
          else {
            this.$alertMsg(response.data.data.text);
          }
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
    getMonitoringProgramLogGroups() {
      var parameter = {
        ElementTypeId: this.elementTypeId,
        ProgramId: this.monitoringProgramId,
        ListOptions: this.monitoringOptions
      };
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/Hydrology/GetMonitoringProgramLogGroups', parameter)
        .then(response => {
          this.logGroups = response.data.items;
          this.groupOptions.total = response.data.count;
          this.totalRowGroup = response.data.count;
          loader.hide();
        })
        .catch(e => {
          loader.hide();
          this.$router.push('/login');
          return false;
        })
    },
    getLogGroups() {
      var parameter = {
        ElementTypeId: this.elementTypeId,
        ElemenId: this.elementId,
        ListOptions: this.groupOptions
      };
      parameter.ListOptions.filterText = this.search;
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/Log/GetLogGroups', parameter)
        .then(response => {
          this.logGroups = response.data.items;
          this.groupOptions.total = response.data.count;
          this.totalRowGroup = response.data.count;
          loader.hide();
        })
        .catch(e => {
          loader.hide();
          this.$router.push('/login');
          return false;
        })
    },
    getProfileHydrology() {
      axios.post('/account/GetProfileDetails')
        .then(response => {
          if (response.data.data.status == 0) {
            var resp = response.data.item;
            this.bUseMonitoringPrograms = (resp.portalHydrology && resp.portalHydrology === true) ? true : false;
          }
        })
        .catch(e => {
          this.$router.push('/login');
        })
    },
    logPageChange(pInfo) {

      var parameter = {
        ElementTypeId: this.elementTypeId,
        ElemenId: this.elementId,
        GroupId: this.logGroupId,
        LogPerElementId: this.logPerElementId,
        ListOptions: {
          PageSize: pInfo.pageSize,
          Page: pInfo.pageNumber,
          FilterText: this.search
        },
        PeriodBegin: this.periodBeginDate,
        PeriodEnd: this.periodEndDate
      };

      parameter.PeriodBegin.setHours(0, 0, 0, 0);
      parameter.PeriodEnd.setHours(0, 0, 0, 0);

      this.getLogs(parameter);
    },
    getLogs(parameter) {
      parameter.PeriodBegin = moment(parameter.PeriodBegin).format();
      parameter.PeriodEnd = moment(parameter.PeriodEnd).format();
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/Log/GetLogs', parameter)
        .then(response => {

          if (response.data.data.status == 0) {
            this.logReadingBatches = response.data.items;
            this.logsPerElement = response.data.logsPerElement;

            this.logOptions.total = response.data.count;
            this.totalRowLog = response.data.count;
            loader.hide();
            this.active = 'second';
            this.first = false;
            this.second = true;

            this.addColumnHeaders();
            this.addColumnData();

            if (this.bAutoSelectNewRecord) {
              var newRecord = this.finalData[0];
              this.selectReadingBatch(newRecord);
              this.bAutoSelectNewRecord = false;
            }
          }
          else {
            this.$alertMsg(response.data.data.text);
          }
          loader.hide();
        })
        .catch(e => {
          loader.hide();
          this.$router.push('/login');
          return false;
        })
    },
    getElementTypes() {
      var parameters = { PageSize: 1000, Page: 1, FilterText: this.search };
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/Log/GetElementTypes', { Value: parameters })
        .then(response => {
          this.elementTypes = response.data.items;
          loader.hide();
        })
        .catch(e => {
          loader.hide();
          this.$router.push('/login');
          return false;
        })
    },
    onElementSearch(val) {

      if (val.length < 3)
        return;

      var parameter = {
        FilterByCurrentLocation: true,
        ElementTypeId: this.elementTypeId,
        CoordLat: 0,
        CoordLong: 0,
        CoordAccuracy: 0,
        ListOptions: { pageSize: 500, total: 0, page: 1, filterText: val }
      };

      if (this.geoLocation != null) {
        parameter.FilterByCurrentLocation = false;
        parameter.CoordLat = this.geoLocation.coords.latitude;
        parameter.CoordLong = this.geoLocation.coords.longitude;
        parameter.CoordAccuracy = this.geoLocation.coords.accuracy;
      }
      this.getElementsAux(parameter);
    },
    getElementsAux(parameter) {
      if (this.geoLocation != null) {
        parameter.FilterByCurrentLocation = this.bGPSFiltering;
        parameter.CoordLat = this.geoLocation.coords.latitude;
        parameter.CoordLong = this.geoLocation.coords.longitude;
        parameter.CoordAccuracy = this.geoLocation.coords.accuracy;
      }
      axios.post('/Element/GetElements', parameter)
        .then(response => {
          if (response.data.data.status == 0) {
            response.data.items.forEach((item) => { item.fullname = item.name + (item.externalRef.length > 0 ? " - " + item.externalRef: ""); });
            this.elements = response.data.items;
          }
          else {
            this.$alertMsg(response.data.data.text);
          }
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
    getElements() {
      var parameter = {
        FilterByCurrentLocation: true,
        ElementTypeId: this.elementTypeId,
        CoordLat: 0,
        CoordLong: 0,
        CoordAccuracy: 0,
        ListOptions: { pageSize: 1000, total: 0, page: 1 }
      };
      if (this.geoLocation != null) {
        parameter.FilterByCurrentLocation = this.bGPSFiltering;
        parameter.CoordLat = this.geoLocation.coords.latitude;
        parameter.CoordLong = this.geoLocation.coords.longitude;
        parameter.CoordAccuracy = this.geoLocation.coords.accuracy;
      }
      axios.post('/Element/GetElements', parameter)
        .then(response => {
          //console.log("resp", response);
          if (response.status == 200) {
            response.data.items.forEach((item) => { item.fullname = item.name + (item.externalRef.length > 0 ? " - " + item.externalRef : ""); });
            this.elements = response.data.items;
          }
          else {
            this.$alertMsg(response.data.data.text);
          }
        })
        .catch(e => {
          console.log("err", e);
          this.$alertMsg(e);
          //this.$router.push('/login');
          return false;
        })

    },
    selectGroup(value) {
      this.logGroupId = value.groupId;
      this.logPerElementId = value.logPerElementId;
      this.readingBatchId = -1;

      var parameter = {
        ElementTypeId: this.elementTypeId,
        ElemenId: this.elementId,
        GroupId: this.logGroupId,
        LogPerElementId: this.logPerElementId,
        ListOptions: this.logOptions,
        PeriodBegin: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        PeriodEnd: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1)
      };

      parameter.PeriodBegin.setHours(0, 0, 0, 0);
      parameter.PeriodEnd.setHours(0, 0, 0, 0);

      this.getLogs(parameter);
    },
    selectReadingBatch(value) {
      if (value)
        this.readingBatchId = value.groupBatchId;

      if (this.readingBatchId > 0) {
        var logId = this.logReadingBatches.filter(item => item.groupBatchId == this.readingBatchId)[0].readings[0].logId;

        this.getCustomFields(logId);
        this.getAttachments(logId);
      }

    },
    createReadingBatch() {
      var finalDataColumns = this.finalColumns.slice(1);

      finalDataColumns.forEach(
        (item) => {
          item.value = 0;
          item.logId = 0;
        });

      this.editingLog.bShowConfirm = false;
      this.editingLog.items = finalDataColumns;
      this.editingLog.groupBatchId = 0;
      this.editingLog.readingDate = new Date();
      this.editingLog.readingDateAux = moment(this.editingLog.readingDate).subtract(1, 'days').format();
      this.editingLog.readingTime = {
        hours: moment(this.editingLog.readingDateAux).format('HH'),
        minutes: moment(this.editingLog.readingDateAux).format('mm'),
        descr: 'logs.ReadingTime'
      },
      this.editingLog.stampDate = new Date();
      this.editingLog.stampUser = this.loggedInUser;

      this.$root.$emit('log_updated');
      this.showEditLog = true;
    },
    editReadingBatch(logBatch) {
      var finalDataColumns = this.finalColumns.slice(1);

      finalDataColumns.forEach(
        (item) => {
          item.value = logBatch[item.logPerElementId];
          item.logId = this.getLogId(item.logPerElementId, logBatch.groupBatchId);
        });

      this.editingLog.bShowConfirm = false;
      this.editingLog.items = finalDataColumns;
      this.editingLog.groupBatchId = logBatch.groupBatchId;
      this.editingLog.readingDate = logBatch.readingDate;
      this.editingLog.readingDateAux = moment(this.editingLog.readingDate).subtract(1, 'days').format();
      this.editingLog.readingTime = {
        hours: moment(this.editingLog.readingDateAux).format('HH'),
        minutes: moment(this.editingLog.readingDateAux).format('mm'),
        descr: 'logs.ReadingTime'
      },
      this.editingLog.stampDate = logBatch.stampDate;
      this.editingLog.stampUser = logBatch.stampUser;

      this.$root.$emit('log_updated');
      this.showEditLog = true;
    },
    saveCustomFields() {
      if (this.readingBatchId > 0) {
        var logId = this.logReadingBatches.filter(item => item.groupBatchId == this.readingBatchId)[0].readings[0].logId;

        var cFieldsUpd = [];

        this.customFields.items.forEach(item => {
          var cField = {
            CustomFieldId: item.customFieldId,
            StrValue: item.strValue,
            IntValue: item.intValue,
            DblValue: item.dblValue,
            DateValue: item.dateValue,
            DataId: item.dataId
          };
          cFieldsUpd.push(cField);
        });

        let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
        axios.post('/Log/SaveCustomFieldValues', {
          ApplicationId: logId,
          Values: cFieldsUpd
        })
          .then(response => {
            if (response.data.data.status == 0) {
              this.$alertMsg(this.$t('messages.CustomFieldSavedSuccess'), 2);
            }
            else
              this.$alertMsg(response.data.data.text);
            loader.hide();
          })
          .catch((e) => { loader.hide(); this.$alertMsg(e.message); })

      }
    },
    saveReadingBatch() {
      if (this.editingLog.bShowConfirm === true)
        return;

      var sUrl = (this.editingLog.groupBatchId == 0) ? '/Log/InsertLogReadings' : '/Log/UpdateLogReadings';

      this.editingLog.readingDate = new Date(this.editingLog.readingDate);

      this.editingLog.readingDate.setHours(parseInt(this.editingLog.readingTime.hours) + 2);

      this.editingLog.readingDate.setMinutes(parseInt(this.editingLog.readingTime.minutes));

      this.editingLog.readingDate.setSeconds(0);

      var items = [];

      this.editingLog.items.forEach(item => {
        var logReading = {
          LogId: item.logId,
          LogPerElementId: item.logPerElementId,
          ReadingDate: this.editingLog.readingDate,
          Reading: item.value,
          ClockOver: false,
          IsForcedReading: item.isForcedReading
        };
        items.push(logReading);
      })

      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post(sUrl, {
        ElementTypeId: this.elementTypeId,
        ElemenId: this.elementId,
        PeriodBegin: null,
        PeriodEnd: null,
        Readings: items
      })
        .then(response => {
          if (response.data.data.status == 0) {
            this.$alertMsg(this.$t('messages.LogSavedSuccess'), 2);
          }
          else
            this.$alertMsg(response.data.data.text);

          var parameter = {
            ElementTypeId: this.elementTypeId,
            ElemenId: this.elementId,
            GroupId: this.logGroupId,
            LogPerElementId: this.logPerElementId,
            ListOptions: this.logOptions,
            PeriodBegin: this.periodBeginDate,
            PeriodEnd: this.periodEndDate
          };

          parameter.PeriodBegin.setHours(0, 0, 0, 0);
          parameter.PeriodEnd.setHours(0, 0, 0, 0);

          this.bAutoSelectNewRecord = (sUrl.indexOf('Insert') > -1);
          this.getLogs(parameter);

          loader.hide();
          this.showEditLog = false;
        })
        .catch((e) => { loader.hide(); this.$alertMsg(e.message); })
    },
    removeReadingBatch(id) {
      this.DeleteLogBatchId = id;
      this.bShowConfirm = true;
    },
    confirmDeleteYes() {
      var items = [];

      var readings = this.logReadingBatches.filter(t => t.groupBatchId == this.DeleteLogBatchId)[0].readings;

      readings.forEach(item => {
        items.push(item.logId);
      })

      this.DeleteLogBatchId = -1;
      this.bShowConfirm = false;

      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/Log/DeleteLogReadings', {
        ElementTypeId: this.elementTypeId,
        ElemenId: this.elementId,
        LogIds: items
      })
        .then(response => {
          if (response.data.data.status == 0) {
            this.$alertMsg(this.$t('messages.LogBatchDeletedSuccess'), 2);
            var parameter = {
              ElementTypeId: this.elementTypeId,
              ElemenId: this.elementId,
              GroupId: this.logGroupId,
              LogPerElementId: this.logPerElementId,
              ListOptions: this.logOptions,
              PeriodBegin: this.periodBeginDate,
              PeriodEnd: this.periodEndDate
            };

            parameter.PeriodBegin.setHours(0, 0, 0, 0);
            parameter.PeriodEnd.setHours(0, 0, 0, 0);

            this.getLogs(parameter);
            this.readingBatchId = -1;
            loader.hide();
          }
        })
        .catch((e) => { loader.hide(); this.$alertMsg(e.message); })
    },
    confirmDeleteNo() {
      this.DeleteLogBatchId = -1;
      this.bShowConfirm = false;
    },
    addDays(date, days) {
      return new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() + days);
    },
    addMonthsUTC(date, count) {
      if (date && count) {
        var m, d = (date = new Date(+date)).getUTCDate()

        date.setUTCMonth(date.getUTCMonth() + count, 1)
        m = date.getUTCMonth()
        date.setUTCDate(d)
        if (date.getUTCMonth() !== m) date.setUTCDate(0)
      }
      return date
    },
    addMonths(date, count) {
      if (date && count) {
        var m, d = (date = new Date(+date)).getDate()

        date.setMonth(date.getMonth() + count, 1)
        m = date.getMonth()
        date.setDate(d)
        if (date.getMonth() !== m) date.setDate(0)
      }
      return date
    },
    closeDialog() {
      this.showEditLog = false;
    },
    formatDateUI(date) {
      return moment(date).add(1, 'days').format(uiDateFormat);
    },
  },


}
